import {Component} from '@angular/core';
import {Router} from '@angular/router';
import {CommonService} from '../../../services/common.service';

@Component({
  selector: 'static-carousel',
  templateUrl: 'app.component.html',
  styleUrl: 'app.component.scss',
  standalone: false,
})
export class StaticCarouselComponent {
  constructor(private router: Router, public commonService: CommonService) {}
  public categories = [
    {
      title: 'Physical',
      slug: 'body',
      parent_id: null,
      font_icon: '',
      kind: 'offers',
      description: '<p>Body category</p>',
      id: 84,
      imageUrl: '/app/assets/img/homepage/Physical_PC_Homepage.png',
    },
    {
      id: 86,
      title: 'Mental',
      slug: 'mind',
      kind: 'offers',
      parent_id: null,
      font_icon: null,
      imageUrl: '/app/assets/img/homepage/Mental_PC_Homepage.png',
    },
    {
      id: 85,
      title: 'Financial',
      slug: 'life',
      kind: 'offers',
      parent_id: null,
      font_icon: null,
      imageUrl: '/app/assets/img/homepage/Financial_PC_Homepage.png',
    },

    {
      id: 87,
      title: 'Social',
      slug: 'soul',
      kind: 'offers',
      parent_id: null,
      font_icon: null,
      imageUrl: '/app/assets/img/homepage/Social_PC_Homepage.png',
    },
  ];

  public navigate(path) {
    this.commonService.navigate(path);
  }
}
